import {
  AgentTaskEventSchema,
  AgentTaskVerificationStatus,
} from "@redotech/redo-model/agent-task-events";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const verifyTaskOutput_ = z.object({
  status: createEnum(AgentTaskVerificationStatus, {
    enumName: "agent_task_verification_status",
  }),
  feedback: z.string().optional(),
  event: AgentTaskEventSchema,
});
export const VerifyTaskOutput: z.ZodType<VerifyTaskOutput> = verifyTaskOutput_;
export interface VerifyTaskOutput extends z.infer<typeof verifyTaskOutput_> {}

export const verifyTask = {
  name: "verifyTask" as const,
  input: z.object({
    taskId: z.string(),
    autoCompleteOnVerify: z.boolean().optional(),
    evidence: z.string().optional(),
  }),
  output: verifyTaskOutput_,
};
